import type { FrontendWidget } from '../types';
import { JobLocationsInCityComponent } from './JobLocationsInCityComponent';
import type {
  JobLocationsInCityConfig,
  JobLocationsInCityResolved,
} from './types';

export const jobLocationsInCityWidget: FrontendWidget<
  JobLocationsInCityConfig,
  JobLocationsInCityResolved
> = {
  componentType: 'widgets.job-locations-in-city',
  displayName: 'Job Locations In City',
  ComponentA: JobLocationsInCityComponent,
  // No resolveSync — lookup widget. Resolved data arrives from the backend.
};
